import TermDepositWrapper from "@/modules/term-deposit/term-deposit/TermDepositWrapper";
import React from "react";

const TermAndCondition: React.FC = () => {
  return <TermDepositWrapper />;
};

export default TermAndCondition;
